import { API_BASE } from '../config';
import type { CartItem } from '../contexts/CartContext';

export interface CustomerInfo {
  name: string;
  businessName: string;
  phone: string;
}

export interface SendOrderResponse {
  success: boolean;
  message: string;
}

export async function sendOrder(
  cartItems: CartItem[],
  customer: CustomerInfo
): Promise<SendOrderResponse> {
  const payload = {
    customer: {
      name: customer.name,
      businessName: customer.businessName,
      phone: customer.phone,
    },
    products: cartItems.map((ci) => ({
      productId:    ci.product.id,
      nameHebrew:   ci.product.nameHebrew,
      nameEnglish:  ci.product.nameEnglish,
      weight:       ci.product.weight,
      manufacturer: ci.product.manufacturer,
      kashrut:      ci.product.kashrut,
      quantity:     ci.quantity,
    })),
  };

  const res = await fetch(`${API_BASE}/orders/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<SendOrderResponse>;
}
